// Module
var code = "<?xml version=\"1.0\" encoding=\"UTF-8\"?> <svg fill=\"#9AA43E\" version=\"1.1\" viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"m34.711 66.824 52.891-52.895 9.5664 9.5664-62.457 62.574-31.996-31.879 9.6836-9.6797z\" fill-rule=\"evenodd\"/> </svg> ";
// Exports
module.exports = code;